import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'showIcon', 'hideIcon']

  toggle (event) {
    event.preventDefault()
    const isHidden = this.inputTarget.type === 'password'
    this.inputTarget.type = isHidden ? 'text' : 'password'

    if (this.hasShowIconTarget) {
      this.showIconTarget.classList.toggle('hidden', isHidden)
    }
    if (this.hasHideIconTarget) {
      this.hideIconTarget.classList.toggle('hidden', !isHidden)
    }
  }
}
